import axiosToken from "../../api/axiosClient";
import { buildQueryString } from "../../utils/reportUtils";

class SubscriptionReportService {
  async getSummary(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/subscriptions/summary${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  async getList(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/subscriptions/list${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  async getServiceUsage(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/subscriptions/service-usage${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  _handleError(error) {
    return {
      message: error.response?.data?.error || "Erreur abonnements",
      status: error.response?.status,
    };
  }
}

export default new SubscriptionReportService();
